<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Group'"
      [customBack]="'groups'"
      [canGoBack]="true"
      [showLinkIcon]="true"
      [linkIcon]="'trash'"
      (linkAction)="deleteTeam()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }
    @if (loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/img/organization.svg'"
            class="title-size" />
          <tidy-text
            [header]="'Group Detail'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Group Name:'" /><span>&nbsp;</span>
            <tidy-text
              [body]="team?.name"
              [translate]="false" />
            <tidy-text
              [body]="'Edit'"
              class="link"
              (action)="goToEditTeamName()"
              style="margin-left: 5px" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Parent Group:'" /><span>&nbsp;</span>
              @if (parentTeam == undefined) {
                <tidy-text
                  [body]="'None'" />
              }
              @if (parentTeam !== undefined) {
                <tidy-text
                  [body]="parentTeam?.name"
                  [translate]="false" />
              }
              <tidy-text
                [body]="'Edit'"
                class="link"
                (action)="goToEditParentTeam()"
                style="margin-left: 5px" />
            </tidy-row>
          </tidy-card>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-image
                [src]="'assets/img/team.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Group Members'" />
              <tidy-text
                [body]="'Add Member'"
                class="link"
                (action)="goToAddUserToTeamPage()" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="'Add group members to limit their access to only the properties in their groups.'" />
            </tidy-row>
            @for (user of team?.team_members; track user) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text
                  [body]="user?.customer_member_name"
                  (action)="goToUserPage(user?.customer_member_id)"
                  class="link"
                  [translate]="false" />
                <tidy-text
                  style="margin-left: 5px"
                  [body]="'X'"
                  class="link"
                  (action)="removeUserFromTeam(user)" />
              </tidy-row>
            }
            @if (team?.team_members?.length == 0) {
              <tidy-row>
                <tidy-text
                  [helper]="'No group members'" />
              </tidy-row>
            }
          </tidy-card>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-image
                [src]="'assets/img/home.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Properties'" />
              <tidy-text
                [body]="'Add Property'"
                class="link"
                (action)="goToAddPropertyToTeamPage()" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="'Add properties to this group so members can see them and for reporting.'" />
            </tidy-row>
            @for (address of team?.addresses; track address) {
              <tidy-row [alignLastItemRight]="true">
                @if (address?.address_name) {
                  <tidy-text
                    [body]="address?.address_name"
                    [translate]="false" />
                }
                @if (!address?.address_name) {
                  <tidy-text
                    [body]="address.address1 + ((address.address2 == null || address.address2 === '') ? '' : (' ' + address.address2))"
                    [translate]="false" />
                }
                <tidy-text
                  style="margin-left: 5px"
                  [body]="'X'"
                  class="link"
                  (action)="removePropertyFromTeam(address)" />
              </tidy-row>
            }
            @if (team?.addresses?.length == 0) {
              <tidy-row>
                <tidy-text
                  [helper]="'No properties'" />
              </tidy-row>
            }
          </tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [header]="'Notifications'" />
            <tidy-text
              [body]="'Add Notifications'"
              class="link"
              (action)="goToAddNotificationsPage()" />
          </tidy-row>
          @if (notificationSettings?.length == 0) {
            <tidy-alert>
              <tidy-row>
                <tidy-text
                  [body]="'No notifications added'" />
              </tidy-row>
            </tidy-alert>
          }
          @for (notification of notificationSettings; track notification) {
            <tidy-card>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/alert.svg'"
                  class="header-size" />
                <tidy-text
                  [header]="notification.display_name | titlecase" />
              </tidy-row>
              @for (channel of notification.channels; track channel) {
                <tidy-row>
                  <tidy-text
                    [body]="channel?.name?.substring(0,37) + (channel?.name?.length > 37 ? '...' : '')"
                    [translate]="false" />
                  <tidy-text
                    class="link"
                    [actionBody]="'X'"
                    style="margin-left:5px"
                    (action)="removeEvent(notification, channel)" />
                </tidy-row>
              }
            </tidy-card>
          }
          <tidy-row [alignLastItemRight]="userRole !== 'member'">
            <tidy-text
              [header]="'Group Billing'" />
            @if (userRole !== 'member' && !teamCard) {
              <tidy-text
                [body]="'Add Card'"
                class="link"
                (action)="goToAddTeamCardPage()" />
            }
            @if (userRole !== 'member' && teamCard) {
              <tidy-text
                [body]="'Replace Card'"
                class="link"
                (action)="goToAddTeamCardPage()" />
            }
          </tidy-row>
          @if (!teamCard) {
            <tidy-alert>
              <tidy-row>
                <tidy-text
                  [body]="'Add a card to use only for jobs done for these properties. This enables Group Billing.'" /><span>&nbsp;</span>
                  <tidy-text
                    [actionBody]="'Learn More'"
                    class="link"
                    (action)="goToLearnMoreTeamBilling()" />
                </tidy-row>
              </tidy-alert>
            }
            @if (teamCard) {
              <tidy-payment-method-card
                [teamId]="team.id"
                [paymentMethod]="teamCard"
                (action)="handleAction($event)" />
            }
            @if (windowService.isDesktopRes) {
              <tidy-row [align]="'center'">
                <tidy-text
                  [actionBody]="'Delete Group'"
                  class="link red"
                  (action)="deleteTeam()" />
              </tidy-row>
            }
          }
        </tidy-wrapper>
      </ng-template>


      @if (!isRightSideContent) {
        <app-scroll-wrapper [templateContent]="content" />
      }

      @if (isRightSideContent) {
        <ion-content class="ion-content-right-column">
          <ng-container *ngTemplateOutlet="content" />
        </ion-content>
      }
